export const IDENTITY_QUESTION_TITLES = Object.freeze([
  "Каков этот мир?",
  "Кто я?",
  "Каково моё место?",
  "Чего я хочу?",
]);
